import Analytics from 'analytics'
import googleAnalytics from '@analytics/google-analytics'

let analytics = null

const init = (measurementId) => {
  if (!measurementId) return
  try {
    analytics = Analytics({
      app: 'nimi',
      plugins: [
        googleAnalytics({
          measurementIds: [measurementId]
        })
      ]
    })
  } catch (error) {
    console.error('googleAnalyticsService error', error)
  }
}

const pageView = () => {
  if (!analytics) return
  try {
    const url = window.location.href
    analytics.page({ url })
  } catch (error) {
    console.error('googleAnalyticsService error', error)
  }
}

const initCheckout = (params) => {
  if (!analytics) return
  try {
    analytics.track('begin_checkout', params)
  } catch (error) {
    console.error('googleAnalyticsService error', error)
  }
}

const purchase = (params) => {
  if (!analytics) return
  try {
    analytics.track('purchase', params)
  } catch (error) {
    console.error('googleAnalyticsService error', error)
  }
}


export default {
  init,
  pageView,
  initCheckout,
  purchase
}